var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgU2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.09379,
    cy: 3.80604,
    r: 2.89121,
    stroke: "#78B1BE",
    strokeWidth: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.95625 12.578C0.95625 10.6726 2.50087 9.12802 4.40625 9.12802H9.78125C11.6866 9.12802 13.2312 10.6726 13.2312 12.578V13.6352C13.2312 14.436 12.5821 15.0852 11.7812 15.0852H2.40625C1.60544 15.0852 0.95625 14.436 0.95625 13.6352V12.578Z",
    stroke: "#78B1BE",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU2);
export default __webpack_public_path__ + "static/media/u2.b27d7f79eb8736aa85c6ab2921eb72eb.svg";
export { ForwardRef as ReactComponent };